export default class EmployeesFilter {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.employeeTypeToken = "";
    this.textSearch = "";
  }
  fillData(data) {
    this.employeeTypeToken = data.employeeTypeToken;
    this.textSearch = data.textSearch;
  }
}
